import { type FieldError } from 'react-hook-form';

import { type LangFn } from '~/src/polyglot';

export function getErrorMessage(error: FieldError, lang: LangFn): string {
  if (error.type === 'required') {
    return lang({ message: 'CREATE_PASSWORD.ERROR.REQUIRED' });
  }

  if (error.type === 'minLength') {
    return lang({ message: 'CREATE_PASSWORD.ERROR.MIN_LENGTH' });
  }

  return lang({ message: 'CREATE_PASSWORD.ERROR.MISMATCH' });
}
